import React from 'react';

import { Link, Outlet, useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import {
  LayoutDashboard,
  Users,
  UserPlus,
  CalendarCheck,
  UserRound,
  Briefcase,
  Wallet,
  Store,
  LayoutGrid,
  Settings,
} from 'lucide-react';

import Logo from '../../../Assets/Logo/white.png';
import DashboardBg from '../../../Assets/Random/DashboardBg.png';

import { TypoPoppins } from '../../../Components/Typo';

import { COLORS } from '../../../Constant/COLORS';

import useHandleLogout from '../../../Hooks/useHandleLogout';

import MobileNavWrapper from './MobileNavWrapper';

import NavLinkLayout from './NavLinkLayout';

function DashboardLayout() {
  const handleLogout = useHandleLogout();
  const navigate = useNavigate();

  const handleClickLogout = async () => {
    await handleLogout();
    navigate('/admin/login');
  };

  return (
    <Stack direction={{ xs: 'column', md: 'row' }}>
      <MobileNavWrapper>
        <Box
          position='relative'
          minHeight='100vh'
          sx={{
            backgroundImage: `url(${DashboardBg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            isolation: 'isolate',
            '&::after': {
              content: '""',
              background: `linear-gradient(180deg, ${COLORS.tealDark} 0%, ${COLORS.teal} 100%)`,
              opacity: 0.93,
              position: 'absolute',
              inset: '0',
              zIndex: '-1',
            },
          }}
        >
          <Box pt={2} px={1} whiteSpace='nowrap'>
            <Link to='/'>
              <img
                width={120}
                height={40}
                src={Logo}
                alt='Logo'
                style={{ display: 'table', marginInline: 'auto' }}
              />
            </Link>
            <Divider
              variant='middle'
              sx={{
                borderColor: 'rgba(255,255,255,0.22)',
                mt: '1em',
                mb: '1em',
              }}
            />
            <List
              sx={{
                '.Mui-selected': {
                  backgroundColor: 'rgba(255,255,255,0.16) !important',
                },
              }}
            >
              <NavLinkLayout to='dashboard' text='Dashboard' icon={LayoutDashboard} />
              <NavLinkLayout to='professionals' text='Professionals' icon={Users} />
              <NavLinkLayout
                to='professionals-request'
                text='Professionals request'
                icon={UserPlus}
              />
              <NavLinkLayout to='booking-request' text='Booking History' icon={CalendarCheck} />
              <NavLinkLayout to='client' text='Client' icon={UserRound} />
              <NavLinkLayout to='job-manage' text='Job Manage' icon={Briefcase} />
              {/* <NavLinkLayout to='transaction' text='Transaction' /> */}

              <Tooltip title='Feature not available'>
                <ListItem disablePadding sx={{ mb: 0.5 }}>
                  <ListItemButton
                    disabled
                    sx={{ color: 'white', borderRadius: 2, gap: 1.25 }}
                  >
                    <Wallet size={18} strokeWidth={1.8} />
                    Transaction
                  </ListItemButton>
                </ListItem>
              </Tooltip>
              <NavLinkLayout to='services' text='Services' icon={Store} />
              <NavLinkLayout to='categories' text='Categories' icon={LayoutGrid} />
              <NavLinkLayout to='manage' text='Manage' icon={Settings} />
            </List>
          </Box>
        </Box>
      </MobileNavWrapper>

      <Box flex='1 1' minWidth='0'>
        <Stack
          direction='row'
          py={{ xs: 1.5, md: 3 }}
          px={{ xs: 2.5, md: 5 }}
          gap={2}
          alignItems='center'
        >
          <Typography variant='h5'>Dashboard</Typography>

          <Button variant='text' sx={{ ml: 'auto' }} onClick={handleClickLogout}>
            <TypoPoppins
              variant='body1'
              fontWeight={500}
              color={COLORS.blue}
              sx={{ pointerEvents: 'none' }}
            >
              Logout
            </TypoPoppins>
          </Button>
        </Stack>
        <Divider />
        <Outlet />
      </Box>
    </Stack>
  );
}

export default DashboardLayout;
